export default __webpack_public_path__ + "static/media/ic_lesotho.39c99b3f.svg";